/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".payslip-revert .GetHelp{display:block;margin-left:unset;margin-top:10px}.margin-bottom-1{margin-bottom:.5rem}"];
export { styles as styles };
